import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "audio-mixer",
  templateUrl: "./audioMixer.component.html",
  styleUrls: ["./audioMixer.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AudioMixerComponent {}
